/* ================================================
   PulsePro Shopify Theme JS
   File: assets/pulsepro.js
   ================================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ---- CUSTOM CURSOR ---- */
  const cursor = document.getElementById('pp-cursor');
  const ring = document.getElementById('pp-cursorRing');

  if (cursor && ring) {
    let mx = 0, my = 0, rx = 0, ry = 0;

    document.addEventListener('mousemove', function(e) {
      mx = e.clientX;
      my = e.clientY;
      cursor.style.left = (mx - 6) + 'px';
      cursor.style.top  = (my - 6) + 'px';
    });

    function animateRing() {
      rx += (mx - rx - 18) * 0.12;
      ry += (my - ry - 18) * 0.12;
      ring.style.left = rx + 'px';
      ring.style.top  = ry + 'px';
      requestAnimationFrame(animateRing);
    }
    animateRing();
  }

  /* ---- SCROLL-TRIGGERED FADE-IN ---- */
  var fadeEls = document.querySelectorAll(
    '.pp-product-card, .pp-feature-item, .pp-testimonial-card'
  );

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  fadeEls.forEach(function(el) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity 0.6s ease, transform 0.6s ease, border-color 0.3s';
    observer.observe(el);
  });

  /* ---- AJAX ADD TO CART ---- */
  window.ppAddToCart = function(variantId, btn) {
    if (!variantId) return;

    var originalText = btn ? btn.textContent : '';
    if (btn) {
      btn.classList.add('loading');
      btn.textContent = 'Adding...';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(res) {
      if (!res.ok) throw new Error('Cart error');
      return res.json();
    })
    .then(function() {
      ppShowToast('✓ Added to cart!');
      ppUpdateCartCount();
      if (btn) {
        btn.textContent = '✓ Added!';
        setTimeout(function() {
          btn.textContent = originalText;
          btn.classList.remove('loading');
        }, 2000);
      }
    })
    .catch(function(err) {
      console.error('Add to cart error:', err);
      ppShowToast('⚠ Something went wrong');
      if (btn) {
        btn.textContent = originalText;
        btn.classList.remove('loading');
      }
    });
  };

  /* ---- TOAST NOTIFICATION ---- */
  window.ppShowToast = function(message) {
    var toast = document.getElementById('pp-toast');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('show');
    setTimeout(function() { toast.classList.remove('show'); }, 2500);
  };

  /* ---- UPDATE CART COUNT IN HEADER ---- */
  window.ppUpdateCartCount = function() {
    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        // Update any cart count elements your theme uses
        var countEls = document.querySelectorAll('.cart-count, [data-cart-count]');
        countEls.forEach(function(el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function(err) { console.error('Cart count error:', err); });
  };

});